/* eslint-disable no-mixed-operators */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, createRef, useState, useRef, useMemo } from "react";
import { usePageApiQueue } from "../../Components/Hooks/PageApiQueue";
import {
  Card,
  CardBody,
  CardHeader,
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  Row,
  Col,
  Table,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  ButtonGroup,
  Input,
  Label,
  Nav, NavItem, NavLink, TabContent, TabPane
} from "reactstrap";
import { currencyFormat, currencyFormatWithoutDecimal, currencyFormatWithAlert } from "../../helpers/api_helper";
import DataTable from "react-data-table-component";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { POST_MENU_OPTIMIZATION } from "../../helpers/data_helper";
import { POST_KPI_DASHBOARD } from "../../helpers/data_helper";
import Loader from "../../Components/Common/Loader";
import { getDateByName, convertDateFormate } from "../../helpers/api_helper";
import CustomPagination from "../../Components/Common/CustomPagination";
import classnames from "classnames";
import CourseBadge from "../../Components/Common/CourseBadge";
import PerformanceBadge from "../../Components/Common/PerformanceBadge";
import { useSelector } from "react-redux";

const itemsPerPage = 50;

const PortfolioAnalysis = ({
  globalDate,
  rightFilter,
  comparisonDate,
  globalCustomDate,
  activeComparisonData,
  mealPeriod,
  defaultCourse,
  selectedPage,
  setSelectedPage,
  recalculate,
  menuItemData,
  currency,
  eventFilter
}) => {
  const [showModelPopup, setShowModelPopup] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [pageCount_ServerTable, setPageCount_ServerTable] = useState(0);
  const [sellingItemAjax, setSellingItemAjax] = useState(true);
  const [sellingItem, setSellingItem] = useState([]);
  const [CategoryData, setCategoryData] = useState([]);
  const [ItemsData, setItemsData] = useState([]);
  const [showRecommendModal, setShowRecommendModal] = useState(false);
  const [showVisualModal, setShowVisualModal] = useState(false);
  const [selectedPage_ServerTable, setselectedPage_ServerTable] = useState(0);
  const ShowModelPopupToggle = () => {
    setShowModelPopup(!showModelPopup);
  };
  const [menuItemAjaxModal, setMenuItemAjaxModal] = useState(true);

  const { enqueue } = usePageApiQueue();
  const controllerRef = useRef(null);
  useEffect(() => {
    setSellingItemAjax(true);
    let leftFilterData = false;
    if (
      globalDate.value !== "Custom" ||
      (globalDate.value === "Custom" &&
        globalCustomDate[0] &&
        globalCustomDate[1])
    ) {
      leftFilterData =
        globalDate.value === "Custom"
          ? {
            from: convertDateFormate(globalCustomDate[0]),
            to: convertDateFormate(globalCustomDate[1]),
          }
          : getDateByName(globalDate.value);
    }
    if (leftFilterData) {
      handleSort(SortColumn, 'initial');
    }
  }, [
    globalDate,
    globalCustomDate,
    mealPeriod,
    defaultCourse,
    selectedPage,
    recalculate,
    eventFilter,
  ]);

  /******** Sorting **** Starts*****/
  const [SortColumn, setsortColumn] = useState('');
  const [isRotatedname, setIsRotatedname] = useState(false);
  const [isRotatedsold, setIsRotatedsold] = useState(false);
  const [isRotatedsell_price, setIsRotatedsell_price] = useState(false);
  const [isRotateditem_cost, setIsRotateditem_cost] = useState(false);
  const [isRotatedsales_mix, setIsRotatedsales_mix] = useState(false);
  const [isRotatedrevenueMix, setIsRotatedrevenueMix] = useState(false);
  const [isRotatedcost, setIsRotatedcost] = useState(false);
  const [isRotateditem_gross_profit, setIsRotateditem_gross_profit] = useState(false);
  const [courseModalDetailAjax, setcourseModalDetailAjax] = useState(true);
  const [limitdroddown, setlimitdroddown] = useState('50');
  const [SortType, setSortType] = useState('ASC');

    const { courses } = useSelector((state) => ({
        courses: state.Dashboard.filterData.courses || [],
    }));

  const courseColorMap = useMemo(() => {
      const map = new Map();
  
      courses.forEach(course => {
          if (course.label) {
                map.set(course.label, {
                    bg: course.badge_bg || null,
                    text: course.badge_text || null,
              });
            }
      });
  
      return map;
  }, [courses]);

  const getColorByLabel = (label) => {
      const colorObj = courseColorMap.get(label);

      if (!colorObj || !colorObj.bg) {
          return {
            backgroundColor: "#405189",
            color: "#FFFFFF"
          }; // No color assigned
      }

      return {
          backgroundColor: colorObj.bg,
          color: colorObj.text || "#000000",
      };
  };

  const handleSort = (value, callfrom) => {
    if (controllerRef.current) {
      controllerRef.current();
    }
    const runQueued = (execute) => {
      controllerRef.current = enqueue("PortfolioAnalysisApi", 4, execute);
    };
    let sorttypefinalvalue;
    if (callfrom === 'initial') {
      sorttypefinalvalue = localStorage.getItem('Portfolio_analysis_SortType');
    } else {
      if (localStorage.getItem('Portfolio_analysis_SortType') === '') {
        localStorage.setItem('Portfolio_analysis_SortType', 'ASC');
        sorttypefinalvalue = 'ASC';
      } else {
        if (localStorage.getItem('Portfolio_analysis_SortType') === 'ASC') {
          localStorage.setItem('Portfolio_analysis_SortType', 'DESC');
          sorttypefinalvalue = 'DESC';
        } else {
          localStorage.setItem('Portfolio_analysis_SortType', 'ASC');
          sorttypefinalvalue = 'ASC';
        }
      }
    }

    setsortColumn(value);

    if (value === 'avg_check') {
      setIsRotatedsold(!isRotatedsold);
    }
    if (value === 'revenue') {
      setIsRotatedsell_price(!isRotatedsell_price);
    }
    if (value === 'sales_mix') {
      setIsRotatedsales_mix(!isRotatedsales_mix);
    }
    if (value === 'revenue_mix') {
      setIsRotatedrevenueMix(!isRotatedrevenueMix);
    }
    if (value === 'cost') {
      setIsRotatedcost(!isRotatedcost);
    }
    if (value === 'gross_profit') {
      setIsRotateditem_gross_profit(!isRotateditem_gross_profit);
    }

    setSellingItemAjax(true);
    let leftFilterData = false;
    if (
      globalDate.value !== "Custom" ||
      (globalDate.value === "Custom" &&
        globalCustomDate[0] &&
        globalCustomDate[1])
    ) {
      leftFilterData =
        globalDate.value === "Custom"
          ? {
            from: convertDateFormate(globalCustomDate[0]),
            to: convertDateFormate(globalCustomDate[1]),
          }
          : getDateByName(globalDate.value);
    }
    if (leftFilterData) {
        runQueued(async (signal) => {
          try {
            const response = await postDataAPI({
          dateFilter: leftFilterData,
          serviceName: POST_MENU_OPTIMIZATION.serviceName,
          op: POST_MENU_OPTIMIZATION.performance_analysis,
          mealPeriod: mealPeriod,
          course: defaultCourse,
          event_filter: eventFilter,
          page: 0,
          recalculate: false,
          sort_column: '',
          sort_type: ''
        }, signal);
            if (signal.aborted) return;
            {
          if (response.status === "ok") {

            let setarr = [];
            let item_sold;
            let revenue;
            let cost;
            let avg_check;
            let sales_mix;
            let revenue_mix;
            let gross_profit;
            let count;
            let avg_cm;
            let avg_sold;

            if (response.data.totalRow && response.data.totalRow.total) {
              Object.keys(response.data.totalRow.total).forEach(key => {
                // console.log(`${key}: ${response.data.totalRow.total[key]}`);            
                if (key === 'item_sold') {
                  item_sold = response.data.totalRow.total[key]
                }
                if (key === 'revenue') {
                  revenue = response.data.totalRow.total[key]
                }
                if (key === 'cost') {
                  cost = response.data.totalRow.total[key]
                }
                if (key === 'avg_check') {
                  avg_check = response.data.totalRow.total[key]
                }
                if (key === 'sales_mix') {
                  sales_mix = response.data.totalRow.total[key]
                }
                if (key === 'revenue_mix') {
                  revenue_mix = response.data.totalRow.total[key]
                }
                if (key === 'gross_profit') {
                  gross_profit = response.data.totalRow.total[key]
                }
                if (key === 'count') {
                  count = response.data.totalRow.total[key]
                }
                if (key === 'avg_cm') {
                  avg_cm = response.data.totalRow.total[key]
                }
                if (key === 'avg_sold') {
                  avg_sold = response.data.totalRow.total[key]
                }
              });

              setarr.unshift({
                "performance_group": "Total",
                "item_sold": item_sold,
                "revenue": revenue,
                "cost": cost,
                "avg_check": avg_check,
                "sales_mix": sales_mix,
                "revenue_mix": revenue_mix,
                "gross_profit": gross_profit,
                "count": count,
                "avg_cm": avg_cm,
                "avg_sold": avg_sold
              });
            }

            if (response.data.data) {
              for (let i = 0; i < response.data.data.length; i++) {
                setarr.push(response.data.data[i]);
              }
            }
            //console.log(setarr)     
            setSellingItem(setarr);

            // setPageCount(Math.ceil(response.data.totalData / limitdroddown));
            // setPageCount(Math.ceil(sellingItem.length / limitdroddown));

          } else {
            //console.log(response);
            // setPageCount(0);
          }
        }
          } catch (err) {
            if (err.code === "ERR_CANCELED" || signal.aborted) {
              return;
            }
            console.error(err);
          } finally {
            if (!signal.aborted) setSellingItemAjax(false);
          }
        });
     
    }

  };
  /************END Sorting**************/

  /*********** Item Name Modal ********/
  const [justifyTab, setjustifyTab] = useState("course");
  const justifyToggle = (tab) => {
    if (justifyTab !== tab) {
      setjustifyTab(tab);
    }
  };
  const [modalItemName, setModalItemName] = useState(false);
  const [modalItem, setModalItem] = useState('');
  const [CorrelationTableMsg, setCorrelationTableMsg] = useState('');
  function togItemName() {
    setModalItemName(!modalItemName);
  }
  let [ItemNameArray, setItemNameArray] = useState([]);
  const [menuItemDataModal, setMenuItemDataModal] = useState({
    Courses: [],
    MenuItems: [],
  });
  const [item_revenue_chkcount, setitem_revenue_chkcount] = useState([]);

  // const handleItemName = (item) => {    
  //   setModalItem(item);
  //   setModalItemName(true);
  //   for (let i = ItemNameArray.length - 1; i >= 0; i--) {
  //     ItemNameArray.splice(i, 1);
  //   }
  //   ItemNameArray.push(item);
  //   let leftFilterData = false;

  //   /****** CALL RIght Graph API ******/
  //   if (
  //     globalDate.value !== "Custom" ||
  //     (globalDate.value === "Custom" &&
  //       globalCustomDate[0] &&
  //       globalCustomDate[1])
  //   ) {
  //     leftFilterData =
  //       globalDate.value === "Custom"
  //         ? {
  //           from: convertDateFormate(globalCustomDate[0]),
  //           to: convertDateFormate(globalCustomDate[1]),
  //         }
  //         : getDateByName(globalDate.value);
  //   }
  //   if (leftFilterData) {
  //     setcourseModalDetailAjax(true);
  //     postDataAPI({
  //       dateFilter: leftFilterData,
  //       serviceName: POST_MENU_OPTIMIZATION.serviceName,
  //       op: POST_MENU_OPTIMIZATION.performance_analysis_by_category,        
  //       mealPeriod: mealPeriod,
  //       course: defaultCourse,
  //       page: 0,
  //       recalculate: false,
  //       sort_column: '',
  //       sort_type: '',
  //       pgroup_name: item.performance_group
  //     }).then((response) => {
  //       setcourseModalDetailAjax(false);
  //       if (response.status === "ok") {          

  //         let setCategoryarr = [];
  //         let setarr = [];                     
  //         let item_sold;
  //         let revenue;
  //         let cost;
  //         let avg_check;
  //         let sales_mix;
  //         let revenue_mix;
  //         let gross_profit;
  //         let count;
  //         let avg_cm;
  //         let avg_sold;

  //         Object.keys(response.data.totalRow.total).forEach(key => {
  //           // console.log(`${key}: ${response.data.totalRow.total[key]}`);            
  //           if(key === 'item_sold'){
  //             item_sold = response.data.totalRow.total[key]
  //           }
  //           if(key === 'revenue'){
  //             revenue = response.data.totalRow.total[key]
  //           }
  //           if(key === 'cost'){
  //             cost = response.data.totalRow.total[key]
  //           }
  //           if(key === 'avg_check'){
  //             avg_check = response.data.totalRow.total[key]
  //           }
  //           if(key === 'sales_mix'){
  //             sales_mix = response.data.totalRow.total[key]
  //           }
  //           if(key === 'revenue_mix'){
  //             revenue_mix = response.data.totalRow.total[key]
  //           }
  //           if(key === 'gross_profit'){
  //             gross_profit = response.data.totalRow.total[key]
  //           } 
  //           if(key === 'count'){
  //             count = response.data.totalRow.total[key]
  //           }   
  //           if(key === 'avg_cm'){
  //             avg_cm = response.data.totalRow.total[key]
  //           }
  //           if(key === 'avg_sold'){
  //             avg_sold = response.data.totalRow.total[key]
  //           }          
  //         });

  //         setarr.unshift({
  //           "name": "Total",
  //                 "item_sold": item_sold,
  //                 "revenue": revenue,
  //                 "cost": cost,
  //                 "avg_check": avg_check,
  //                 "sales_mix": sales_mix,
  //                 "revenue_mix": revenue_mix,
  //                 "gross_profit": gross_profit,
  //                 "performance_group": '',
  //                 "count": count,
  //                 "avg_cm": avg_cm,
  //                 "avg_sold": avg_sold
  //         });

  //         for(let i=0;i<response.data.data.itemResult.length;i++){            
  //           setarr.push(response.data.data.itemResult[i]);                                 
  //         }
  //         setItemsData(setarr);

  //         setCategoryarr.unshift({
  //           "course_name": "Total",
  //           "item_sold": item_sold,
  //           "revenue": revenue,
  //           "cost": cost,
  //           "avg_check": avg_check,
  //           "sales_mix": sales_mix,
  //           "revenue_mix": revenue_mix,
  //           "gross_profit": gross_profit,
  //           "performance_group": '',
  //           "count": count,
  //           "avg_cm": avg_cm,
  //           "avg_sold": avg_sold
  //         });
  //         for(let i=0;i<response.data.data.courseResult.length;i++){                         
  //             setCategoryarr.push(response.data.data.courseResult[i]);                  
  //         }                                        
  //         setCategoryData(setCategoryarr);          

  //       } else {
  //         console.log(response);
  //       }
  //     });
  //   } else {
  //     //console.log(1);
  //   }
  //   /***** END *****/

  // }

  const handleItemName = (item) => {
    setModalItem(item);
    setModalItemName(true);

    // Clear ItemNameArray
    ItemNameArray.length = 0;
    ItemNameArray.push(item);

    let leftFilterData = false;

    // Prepare date filter
    if (
      globalDate.value !== "Custom" ||
      (globalDate.value === "Custom" && globalCustomDate[0] && globalCustomDate[1])
    ) {
      leftFilterData =
        globalDate.value === "Custom"
          ? {
            from: convertDateFormate(globalCustomDate[0]),
            to: convertDateFormate(globalCustomDate[1]),
          }
          : getDateByName(globalDate.value);
    }

    if (!leftFilterData) {
      return;
    }

    setcourseModalDetailAjax(true);
    try {
      postDataAPI({
        dateFilter: leftFilterData,
        serviceName: POST_MENU_OPTIMIZATION.serviceName,
        op: POST_MENU_OPTIMIZATION.performance_analysis_by_category,
        mealPeriod: mealPeriod,
        course: defaultCourse,
        event_filter: eventFilter,
        page: 0,
        recalculate: false,
        sort_column: '',
        sort_type: '',
        pgroup_name: item.performance_group
      }).then((response) => {
        setcourseModalDetailAjax(false);

        if (response.status !== "ok") {
          console.log(response);
          return;
        }

        /** -------------------------
         * COURSE TAB TOTAL
         * Uses API totalRow.total
         ------------------------- **/
        let totalRow = (response.data.totalRow && response.data.totalRow.total) ? response.data.totalRow.total : {};
        let courseTotal = {
          course_name: "Total",
          item_sold: totalRow.item_sold || 0,
          revenue: totalRow.revenue || 0,
          cost: totalRow.cost || 0,
          avg_check: totalRow.avg_check || 0,
          sales_mix: totalRow.sales_mix || 0,
          revenue_mix: totalRow.revenue_mix || 0,
          gross_profit: totalRow.gross_profit || 0,
          performance_group: '',
          count: totalRow.count || 0,
          avg_cm: totalRow.avg_cm || 0,
          avg_sold: totalRow.avg_sold || 0
        };

        let courseResult = (response.data.data && response.data.data.courseResult) ? response.data.data.courseResult : [];
        let categoryArr = [courseTotal, ...courseResult];
        setCategoryData(categoryArr);

        /** -------------------------
         * ITEM TAB TOTAL
         * Calculated from itemResult
         ------------------------- **/
        let totalItemSold = 0,
          totalRevenue = 0,
          totalCost = 0,
          totalGrossProfit = 0,
          totalSalesMix = 0,
          totalRevenueMix = 0,
          totalCount = 0,
          totalAvgCM = 0,
          totalAvgSold = 0;

        let itemResult = (response.data.data && response.data.data.itemResult) ? response.data.data.itemResult : [];
        itemResult.forEach(it => {
          totalItemSold += Number(it.item_sold) || 0;
          totalRevenue += Number(it.revenue) || 0;
          totalCost += Number(it.cost) || 0;
          totalGrossProfit += Number(it.gross_profit) || 0;
          totalSalesMix += Number(it.sales_mix) || 0;
          totalRevenueMix += Number(it.revenue_mix) || 0;
          totalCount += Number(it.count) || 0;
          totalAvgCM += Number(it.avg_cm) || 0;
          totalAvgSold += Number(it.avg_sold) || 0;
        });

        // Calculate average check based on total revenue / total sold
        let avgCheck = totalItemSold ? totalRevenue / totalItemSold : 0;

        let itemTotal = {
          name: "Total",
          item_sold: totalItemSold,
          revenue: totalRevenue,
          cost: totalCost,
          avg_check: avgCheck,
          sales_mix: totalSalesMix,
          revenue_mix: totalRevenueMix,
          gross_profit: totalGrossProfit,
          performance_group: '',
          count: totalCount,
          avg_cm: totalAvgCM,
          avg_sold: totalAvgSold
        };

        let itemsArr = [itemTotal, ...itemResult];
        setItemsData(itemsArr);

      });
    } catch (err) {
      console.error(err);
    }
  };

  /*********** END **********/

  const handleLimit = (e) => {
    setlimitdroddown(e.target.value);
    if (e.target.value !== '') {
      setSellingItemAjax(true);
      let leftFilterData = false;
      if (
        globalDate.value !== "Custom" ||
        (globalDate.value === "Custom" &&
          globalCustomDate[0] &&
          globalCustomDate[1])
      ) {
        leftFilterData =
          globalDate.value === "Custom"
            ? {
              from: convertDateFormate(globalCustomDate[0]),
              to: convertDateFormate(globalCustomDate[1]),
            }
            : getDateByName(globalDate.value);
      }
      if (leftFilterData) {
        postDataAPI({
          dateFilter: leftFilterData,
          serviceName: POST_MENU_OPTIMIZATION.serviceName,
          op: POST_MENU_OPTIMIZATION.performance_analysis,
          mealPeriod: mealPeriod,
          course: defaultCourse,
          event_filter: eventFilter,
          page: 0,
          recalculate: false,
          sort_column: '',
          sort_type: ''
        }).then((response) => {
          setSellingItemAjax(false);
          if (response.status === "ok") {

            let setarr = [];
            let item_sold;
            let revenue;
            let cost;
            let avg_check;
            let sales_mix;
            let revenue_mix;
            let gross_profit;

            if (response.data.totalRow && response.data.totalRow.total) {
              Object.keys(response.data.totalRow.total).forEach(key => {
                // console.log(`${key}: ${response.data.totalRow.total[key]}`);            
                if (key === 'item_sold') {
                  item_sold = response.data.totalRow.total[key]
                }
                if (key === 'revenue') {
                  revenue = response.data.totalRow.total[key]
                }
                if (key === 'cost') {
                  cost = response.data.totalRow.total[key]
                }
                if (key === 'avg_check') {
                  avg_check = response.data.totalRow.total[key]
                }
                if (key === 'sales_mix') {
                  sales_mix = response.data.totalRow.total[key]
                }
                if (key === 'revenue_mix') {
                  revenue_mix = response.data.totalRow.total[key]
                }
                if (key === 'gross_profit') {
                  gross_profit = response.data.totalRow.total[key]
                }
              });
            }

            if (response.data.data) {
              for (let i = 0; i < response.data.data.length; i++) {
                if (i === 0 && (response.data.totalRow && response.data.totalRow.total)) {
                  setarr[0] = (
                    {
                      "performance_group": "Total",
                      "item_sold": item_sold,
                      "revenue": revenue,
                      "cost": cost,
                      "avg_check": avg_check,
                      "sales_mix": sales_mix,
                      "revenue_mix": revenue_mix,
                      "gross_profit": gross_profit
                    }
                  );
                } else {
                  setarr[i] = response.data.data[i];
                }
              }
            }
            setSellingItem(setarr);

          } else {
            console.log(response);
            // setPageCount(0);
          }
        });
      }
    }

  }

  /******** Show and Hide Columns *********/
  const [sortColumn, SetSortColumn] = useState('');
  const columnDef = [
    {
      name: ' ',
      key: 'performance_group',
      className: "text-start",
    },
    {
      name: 'Item Sold',
      key: 'item_sold'
    },
    {
      name: 'Avg Check',
      key: 'avg_check',
      sort: true,
    },
    {
      name: 'Revenue',
      key: 'revenue',
      sort: true,
    },
    {
      name: 'Sales Mix',
      key: 'sales_mix',
    },
    {
      name: 'Revenue Mix',
      key: 'revenue_mix',
    },
    {
      name: 'Cost',
      key: 'cost',
      sort: true,
    },
    {
      name: 'Item Gross Profit',
      key: 'gross_profit',
    },
    {
      name: 'Count',
      key: 'count',
    },
    {
      name: 'Avg CM',
      key: 'avg_cm',
    },
    {
      name: 'Avg Sold',
      key: 'avg_sold',
    }
  ]
  const [showColumns, setShowColumns] = useState(columnDef.map((column) => column.key));
  const [isOpen, setIsOpen] = useState(false);
  const columnDropdownRef = createRef();
  const toggleDropdown = (e) => {
    if (columnDropdownRef.current.contains(e.target)) return;
    setIsOpen(!isOpen);
  };
  const handleColumnHideShow = (event, columnName) => {
    event.stopPropagation();
    if (showColumns.includes(columnName)) {
      setShowColumns(showColumns.filter((column) => column != columnName))
    } else {
      setShowColumns([...showColumns, columnName]);
    }
  }
  /****************************************/

  return (
    <>
      <Card>
        <CardHeader className="align-items-center d-flex">
          <div className="d-flex align-items-start flex-grow-1">
            <div className={`icon-box rounded bg-danger text-white`}>
              <i className="ri-line-chart-line"></i>
            </div>
            <div className="ps-2">
              <h4 className="card-title mb-1">
                Portfolio Analysis
              </h4>
              <p className="text-muted mb-0">
                Menu item classification by sales, revenue mix, cost, and profit.
              </p>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="d-flex">
              <Dropdown isOpen={isOpen} toggle={toggleDropdown} className="ms-3" style={{ borderRadius: '0.25rem', marginRight: '15px' }}>
                <ButtonGroup>
                  <Button color="info">Columns</Button>
                  <DropdownToggle tag="button" className="btn btn-info" split></DropdownToggle>
                </ButtonGroup>
                <DropdownMenu className="dropdown-menu-end" end={true}>
                  <div ref={columnDropdownRef}>
                    {columnDef.map((column) => (
                      <DropdownItem onClick={(event) => { handleColumnHideShow(event, column.key) }} key={column.key}>
                        <div className="form-check mb-1">
                          <Input className="form-check-input" type="checkbox" id={`column${column.key}`} checked={showColumns.includes(column.key)} value={column.key} readOnly />
                          <Label className="form-check-label" for="formCheck6">{column.name}</Label>
                        </div>
                      </DropdownItem>
                    ))}
                  </div>
                </DropdownMenu>
              </Dropdown>
              {/* <span className="p-2">Show</span>
              <select defaultValue="50" className="form-select" id="selling_item_limit" style={{ cursor: 'pointer' }} onChange={handleLimit}>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
              </select>
              <span className="p-2">entries</span> */}
            </div>
          </div>
        </CardHeader>
        <CardBody>
          {sellingItemAjax && <Loader />}
          <div id="PortfolioAnalysis" className={sellingItemAjax ? "opacity-0" : ""}>
            {sellingItemAjax && <Loader />}
            <div
              className={
                sellingItemAjax
                  ? "opacity-0 table-responsive table-card"
                  : "table-responsive table-card"
              }
              style={{ maxHeight: '500px', overflow: 'auto' }}
            >
              <table className="table table-borderless table-centered align-middle table-nowrap mb-0 text-center">
                <thead className="text-muted table-light">
                  <tr style={{ position: 'sticky', top: '-2px', zIndex: 100 }}>
                    {columnDef.map((column) => (
                      // eslint-disable-next-line no-undef
                      // showColumns.includes(column.key) && <th className={column.className} key={column.key} scope="col">{column.performance_group} {column.sort && <i className="las la-arrow-down" style={{ cursor: 'pointer', transform: (sortColumn == column.key && sorttypefinalvalue == 'DESC' ? 'rotate(180deg)' : 'rotate(0deg)') }} onClick={() => handleSort(column.key, 'sortcall')}></i>}</th>
                      showColumns.includes(column.key) && <th className={column.className} key={column.key} scope="col">{column.name}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {(sellingItem || []).map((item, key) => (
                    <tr key={key}>
                      {showColumns.includes('performance_group') && (
                        <td
                          className="text-start"
                          onClick={() => handleItemName(item)}
                          style={{ cursor: 'pointer' }}
                        >
                          {item.performance_group !== "Total" ? (
                            <span
                              className={`badge bg-${item.performance_group === "Plowhorse"
                                ? "warning"
                                : item.performance_group === "Dog"
                                  ? "danger"
                                  : item.performance_group === "Cash Cow"
                                    ? "warning"
                                    : item.performance_group === "Puzzle"
                                      ? "light text-dark"
                                      : "success"
                                }`}
                              style={{
                                fontWeight: key === 0 ? 'bold' : 'normal' // Apply bold font style to the first row
                              }}
                            >
                              <b>{item.performance_group}</b>
                            </span>
                          ) : (
                            <b>{item.performance_group}</b>
                          )}

                          {item.performance_group !== "Total" ? (
                            <i
                              className="ri-external-link-line"
                              style={{
                                fontSize: '18px',
                                marginLeft: '10px',
                                position: 'relative',
                                top: '5px',
                                color: '#405189'
                              }}
                            ></i>
                          ) : (
                            ''
                          )}
                        </td>
                      )}
                      {showColumns.includes('item_sold') && (
                        <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                          {item.item_sold}
                        </td>
                      )}
                      {showColumns.includes('avg_check') && (
                        <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                          {currencyFormatWithAlert(item.avg_check, currency)}
                        </td>
                      )}
                      {showColumns.includes('revenue') && (
                        <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                          {currencyFormatWithAlert(item.revenue, currency)}
                        </td>
                      )}
                      {showColumns.includes('sales_mix') && (
                        <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                          {parseFloat(item.sales_mix).toFixed(2) + '%'}
                        </td>
                      )}
                      {showColumns.includes('revenue_mix') && (
                        <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                          {parseFloat(item.revenue_mix).toFixed(2) + '%'}
                        </td>
                      )}
                      {showColumns.includes('cost') && (
                        <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                          {currencyFormatWithAlert(item.cost, currency)}
                        </td>
                      )}
                      {showColumns.includes('gross_profit') && (
                        <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                          <b>{currencyFormatWithAlert(item.gross_profit, currency)}</b>
                        </td>
                      )}
                      {showColumns.includes('count') && (
                        <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                          {item.count}
                        </td>
                      )}
                      {showColumns.includes('avg_cm') && (
                        <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                          {currencyFormatWithAlert(item.avg_cm, currency)}
                        </td>
                      )}
                      {showColumns.includes('avg_sold') && (
                        <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                          {parseFloat(item.avg_sold).toFixed(2)}
                        </td>
                      )}
                    </tr>
                  ))}

                </tbody>
              </table>
            </div>
            {/*<div className="mt-5 float-end">
              <nav>
                <CustomPagination
                  pageCount={pageCount}
                  setSelectedPage={setSelectedPage}
                />
              </nav>
            </div>*/}
          </div>
        </CardBody>
      </Card>

      {/* Modal for onclick Item Name */}
      <Modal className="modal-dialog modal-xl custom-bg" isOpen={modalItemName} toggle={() => { togItemName(); }} id="fullscreeexampleModal">
        <ModalHeader className="modal-title" id="exampleModalFullscreenLabel" toggle={() => { togItemName(); }}>
          {modalItem.performance_group}
        </ModalHeader>
        <ModalBody>
          <Card>
            <CardBody>
              <Nav pills className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3">
                <NavItem>
                  <NavLink style={{ cursor: "pointer", background: "transparent" }} className={classnames({ active: justifyTab === "course", })} onClick={() => { justifyToggle("course"); }} >
                    Course
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink style={{ cursor: "pointer" }} className={classnames({ active: justifyTab === "item", })} onClick={() => { justifyToggle("item"); }} >
                    Item
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={justifyTab} className="text-muted">

                <TabPane tabId="course" id="course">
                  <Card style={{ borderRadius: '0px 0px 8px 8px' }}>
                    <CardBody>
                      {
                        courseModalDetailAjax && <Loader />
                      }
                      {!courseModalDetailAjax && <>
                        <div
                          className={
                            courseModalDetailAjax
                              ? "opacity-0 table-responsive table-card"
                              : "table-responsive table-card"
                          }
                        >
                          <table className="table table-borderless table-centered align-middle table-nowrap mb-3 text-center">
                            <thead className="text-muted table-light">
                              <tr>
                                <th scope="col"></th>
                                <th scope="col">Item Sold</th>
                                <th scope="col">Avg Check</th>
                                <th scope="col">Revenue</th>
                                <th scope="col">Sales Mix</th>
                                <th scope="col">Revenue Mix</th>
                                <th scope="col">Cost</th>
                                <th scope="col">Item Gross Profit</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(CategoryData || []).map((item, key) => (
                                <tr key={key}>
                                  <td
                                    className="text-start"
                                    onClick={() => handleItemName(item)}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    {item.course_name !== "Total" ? (
                                      <span
                                        // className={`badge bg-${item.course_name === "Starter"
                                        //   ? "warning"
                                        //   : item.course_name === "Drinks"
                                        //     ? "danger"
                                        //     : item.course_name === "Main"
                                        //       ? "primary"
                                        //       : item.course_name === "Desserts"
                                        //         ? "success"
                                        //         : item.course_name === "Others"
                                        //           ? "info"
                                        //           : "light text-dark"
                                        //   }`}
                                        // style={{
                                        //   fontWeight: key === 0 ? 'bold' : 'normal' // Apply bold font style to the first row
                                        // }}
                                        style={getColorByLabel(item.course_name)}
                                        className={`badge`}
                                      >
                                        <b>{item.course_name}</b>
                                      </span>
                                    ) : (
                                      <b>{item.course_name}</b>
                                    )}
                                  </td>
                                  <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                                    {item.item_sold}
                                  </td>

                                  <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                                    {currencyFormatWithAlert(item.avg_check, currency)}
                                  </td>

                                  <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                                    {currencyFormatWithAlert(item.revenue, currency)}
                                  </td>

                                  <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                                    {parseFloat(item.sales_mix).toFixed(2) + '%'}
                                  </td>

                                  <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                                    {parseFloat(item.revenue_mix).toFixed(2) + '%'}
                                  </td>

                                  <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                                    {currencyFormatWithAlert(item.cost, currency)}
                                  </td>

                                  <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                                    <b>{currencyFormatWithAlert(item.gross_profit, currency)}</b>
                                  </td>

                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </>
                      }
                    </CardBody>
                  </Card>
                </TabPane>

                <TabPane tabId="item" id="item">
                  <Card style={{ borderRadius: '0px 0px 8px 8px' }}>
                    <CardBody>
                      {
                        courseModalDetailAjax && <Loader />
                      }
                      {!courseModalDetailAjax && <>
                        <div
                          className={
                            courseModalDetailAjax
                              ? "opacity-0 table-responsive table-card"
                              : "table-responsive table-card"
                          }
                          style={{ maxHeight: '500px', overflow: 'auto' }}
                        >
                          <table className="table table-borderless table-centered align-middle table-nowrap mb-3 text-center">
                            <thead className="text-muted table-light">
                              <tr style={{ position: 'sticky', top: '-2px', zIndex: 100 }}>
                                <th scope="col"></th>
                                <th scope="col">Course</th>
                                <th scope="col">Item Sold</th>
                                <th scope="col">Avg Check</th>
                                <th scope="col">Revenue</th>
                                <th scope="col">Sales Mix</th>
                                <th scope="col">Revenue Mix</th>
                                <th scope="col">Cost</th>
                                <th scope="col">Item Gross Profit</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(ItemsData || []).map((item, key) => (
                                <tr key={key}>
                                  <td className="text-start" >
                                    <b>{item.name}</b>
                                  </td>

                                  <td>
                                    {item.course_name ? (
                                      <span
                                        style={getColorByLabel(item.course_name)}
                                        className={`badge`}
                                      >
                                        <b>{item.course_name}</b>
                                      </span>
                                    ) : (
                                      <b>-</b>
                                    )}
                                  </td>

                                  <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                                    {item.item_sold}
                                  </td>

                                  <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                                    {currencyFormatWithAlert(item.avg_check, currency)}
                                  </td>

                                  <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                                    {currencyFormatWithAlert(item.revenue, currency)}
                                  </td>

                                  <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                                    {parseFloat(item.sales_mix).toFixed(2) + '%'}
                                  </td>

                                  <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                                    {parseFloat(item.revenue_mix).toFixed(2) + '%'}
                                  </td>

                                  <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                                    {currencyFormatWithAlert(item.cost, currency)}
                                  </td>

                                  <td style={{ fontWeight: key === 0 ? 'bold' : 'normal' }}>
                                    <b>{currencyFormatWithAlert(item.gross_profit, currency)}</b>
                                  </td>

                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </>
                      }
                    </CardBody>
                  </Card>
                </TabPane>
              </TabContent>

            </CardBody>
          </Card>
        </ModalBody>
      </Modal>

    </>
  );
};

export default PortfolioAnalysis;
